import { DialogClassKey } from "@material-ui/core";
import { StyleRules } from "@material-ui/core/styles";

export const MuiDialog: Partial<StyleRules<DialogClassKey>> = {
  paper: {
    paddingBottom: 8,
    paddingTop: 8,
  },
};
